/**
 * Removes keys from an object where the value is null, undefined, or empty string.
 * @param obj The object to clean
 * @returns A new object with only valid values
 */
export function cleanObject<T extends Record<string, any>>(obj: T): Partial<T> {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) => value !== null && value !== undefined && value !== '',
    ),
  ) as Partial<T>;
}
